import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title?: string
  description?: string
  image?: string
  url?: string
  type?: 'website' | 'article'
}

const defaultMeta = {
  title: 'Garrett John Law | AI Systems & Agent Engineer',
  description:
    'AI systems and agent engineer building production AI on AWS Bedrock — multi-agent fleets, grounded LLM tooling, and automated evaluation engines. AI that does real work behind guardrails.',
  image: '/og-image.jpg',
  url: 'https://garrettjohnlaw.com',
}

export function SEO({
  title,
  description = defaultMeta.description,
  image = defaultMeta.image,
  url = defaultMeta.url,
  type = 'website',
}: SEOProps) {
  const fullTitle = title ? `${title} | Garrett John Law` : defaultMeta.title

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />

      {/* Per-route canonical (prerender de-dupes the static index.html one) */}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Person',
          '@id': 'https://garrettjohnlaw.com/#person',
          name: 'Garrett John Law',
          url: 'https://garrettjohnlaw.com',
          jobTitle: 'AI Systems & Agent Engineer',
          sameAs: [
            'https://linkedin.com/in/garrettjohnlaw',
            'https://github.com/garrettjohnlaw',
            'https://instagram.com/garrettjohnlaw_',
            'https://www.facebook.com/garrett.john.law95',
            'https://www.youtube.com/@garrettjohnlawmusic',
            'https://music.garrettjohnlaw.com',
            'https://fuguelab.com',
            'https://fairmeadow.capital',
            'https://fusionstreetdigital.com',
            'https://classicallyminded.org',
          ],
        })}
      </script>
    </Helmet>
  )
}
